module.exports = __webpack_public_path__ + "img/slide7.ce6b54a2.png";